import Api from 'app/services/Api'

/**
 * get shipping carrier
 */
export const getShippingCarriers = (country?: string): Promise<CarriersModel> =>
  Api.get('/api/v1/shippings/carriers', {
    params: { country },
    deserialize: true
  })

/**
 *  get shipping packages
 */
export const getShippingPackages = (
  params: ShippingPackagesDTO
): Promise<PackagesModel> =>
  Api.get('/api/v1/shippings/packages', {
    params,
    deserialize: true
  })

/**
 * get users shippings by slug
 */
export const getUserShipping = (slug: string): Promise<ShippingModel> =>
  Api.get(`/api/v1/users/shippings/${slug}`, {
    deserialize: true
  })

/**
 * create users shipping
 */
export const createUserShipping = (
  data: Partial<ShippingDTO>
): Promise<ShippingModel> =>
  Api.post(`/api/v1/users/shippings`, {
    data: {
      shipping: data
    },
    deserialize: true
  })

/**
 * update users shipping by slug
 */
export const updateUserShipping = ({
  slug,
  data
}: {
  slug?: string
  data: Partial<ShippingDTO>
}): Promise<ShippingModel> =>
  Api.put(`/api/v1/users/shippings/${slug}`, {
    data: {
      shipping: data
    },
    deserialize: true
  })

/**
 * create users addresses
 */
export const createUserAddresses = (data: AddressDTO): Promise<Address> =>
  Api.post(`/api/v1/users/addresses`, {
    data: {
      address: data
    },
    deserialize: true
  })

/**
 * shipping estimate rate
 */
export const getEstimateRate = (
  data: EstimateRate
): Promise<EstimateRateModel> =>
  Api.post(`/api/v1/shippings/estimate_rate`, {
    data,
    deserialize: true
  })

/**
 * get shipping hs codes
 */
export const getHarmonizedCodes = (keyword: string): Promise<HSCodeModel[]> =>
  Api.get('/api/v1/hs_codes', {
    params: { by_keyword: keyword },
    deserialize: true
  })
